import React, { useState, useEffect, useRef } from "react";
import Loader from "../Loader/loader";
import moment from "moment/moment";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { authHeaders,getSessionToken } from "../cms/utils/session";

const Profile = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    password:"",
  
  });
  const {
    name,
    email,
    mobile,
    password
  } = formData;
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
const [userId, setUserId] = useState('');
  const [nameError, setNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const [plans, setPlans] = useState([]);

  const [token, setToken] = useState(getSessionToken());
  
  let hasError = false;

  useEffect(() => {
    let id = JSON.parse(localStorage.getItem('trade_user_data'))
    setUserId(id?.id)
    setToken(getSessionToken());
    getUserDetail(id?.id);
  }, []);

  const getUserDetail = async (id) => {
    setIsLoading(true);
    const res = await axios.get(`${API_BASE_URL}/get-internal-user-details/${id}`, {
      headers: {
        ...authHeaders(),
      },
    });
    // console.log('res', res); 
    if (res.data.status == 200) {
      setFormData({
        ...formData,
        name: res.data.data.name,
        email: res.data.data.email,
        mobile: res.data.data.mobile,
       password:res.data.data.password,
      });
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log(formData, "form");

    if (!formData.name) {
      setNameError("Please enter name");
      hasError = true;
    } else {
      setNameError("");
    }
    if (!formData.mobile) {
      setMobileError("Please enter mobile ");
      hasError = true;
    } else {
      setMobileError("");
    }
    // if (!formData.password) {
    //     setPasswordError("Please enter Password");
    //     hasError = true;
    //   } else {
    //     setPasswordError("");
    //   }
     
    if (!hasError) {
      let form ={
        id: userId,
        name: name,
        mobile: mobile, 
        password:password,
      }
      axios
        .post(
          `${API_BASE_URL}/update-cms-user-details`,form,
          {
            headers: {
              ...authHeaders(),
            },
          }
        )
        .then((response) => {
          // console.log(response);
          if (response.data.status === 200) {
            toast.success("Updated successfully");
          }
        })
        .catch((error) => {
          toast.error(error.response.data.msg)
        });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    // console.log(event.target, "mame");
    // console.log(name, value, "mame");
    // console.log(formData, "valueeeeeeee");

    if (name === "subscription_end_date") {
      setFormData({ ...formData, [name]: moment(value,'yyyy-mm-dd')});
    }
  };

  const selectStyles = (errorFieldName) => ({
    control: (provided) => ({
      ...provided,
      borderColor: errors[errorFieldName] ? "#dc3545" : provided.borderColor,
      boxShadow: errors[errorFieldName]
        ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
        : provided.boxShadow,
      minHeight: 22,
      height: 33,
    }),
  });

  const handleSelect = (fieldName, selectedOption) => {
    // setSelectedOption(selectedOption);
    // console.log(selectedOption, "opton");
    setFormData({ ...formData, [fieldName]: selectedOption.value });
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));

    if(fieldName == 'subscription_type'){
        if(selectedOption.value == 'free_trial'){
            setFormData({...formData, plan_type:'free_trial', plan_id:'1',subscription_end_date:moment().add(5, 'd').format('YYYY-MM-DD'),[fieldName]: selectedOption.value})
        }
    }
  };

  const avatarInitials = name
    ? name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2)
    : "AD";

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* Page title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">My Profile</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/cms/home">CMS</Link>
                      </li>
                      <li className="breadcrumb-item active">Profile</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            {isLoading ? (
              <Loader />
            ) : (
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-10">
                  {/* Profile card */}
                  <div className="card" style={{ borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 24px rgba(91,72,232,0.10)" }}>
                    {/* Cover banner */}
                    <div style={{
                      background: "linear-gradient(135deg, #1d4ed8 0%, #5b48e8 60%, #7c3aed 100%)",
                      height: 130,
                      position: "relative",
                    }} />

                    {/* Avatar + name header */}
                    <div style={{ padding: "0 32px 24px", position: "relative" }}>
                      {/* Avatar circle */}
                      <div style={{
                        width: 88,
                        height: 88,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #5b48e8, #7c3aed)",
                        border: "4px solid #fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 32,
                        fontWeight: 700,
                        color: "#fff",
                        marginTop: -44,
                        boxShadow: "0 4px 16px rgba(91,72,232,0.25)",
                        letterSpacing: 1,
                      }}>
                        {avatarInitials}
                      </div>

                      <div style={{ marginTop: 12 }}>
                        <h5 style={{ margin: 0, fontWeight: 700, fontSize: 20, color: "#1e293b" }}>{name || "—"}</h5>
                        <p style={{ margin: "4px 0 0", color: "#64748b", fontSize: 14 }}>
                          <i className="bx bx-envelope" style={{ marginRight: 5 }} />{email || "—"}
                        </p>
                      </div>
                    </div>

                    {/* Divider */}
                    <div style={{ height: 1, background: "#f1f5f9", margin: "0 32px" }} />

                    {/* Form */}
                    <div style={{ padding: "28px 32px 32px" }}>
                      <h6 style={{ fontWeight: 700, color: "#334155", marginBottom: 24, fontSize: 15, letterSpacing: 0.3 }}>
                        <i className="bx bx-edit-alt" style={{ marginRight: 8, color: "#5b48e8" }} />
                        Edit Information
                      </h6>

                      <form onSubmit={handleSubmit}>
                        <div className="row g-4">
                          {/* Name */}
                          <div className="col-md-6">
                            <label style={{ fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6, display: "block" }}>
                              Full Name <span style={{ color: "#ef4444" }}>*</span>
                            </label>
                            <div style={{ position: "relative" }}>
                              <i className="bx bx-user" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 16 }} />
                              <input
                                name="name"
                                type="text"
                                value={name}
                                onChange={handleInputChange}
                                placeholder="Enter full name"
                                className={nameError ? "form-control is-invalid" : "form-control"}
                                style={{ paddingLeft: 36, borderRadius: 8, borderColor: nameError ? "#ef4444" : "#e2e8f0", fontSize: 14, height: 42 }}
                              />
                            </div>
                            {nameError && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{nameError}</div>}
                          </div>

                          {/* Mobile */}
                          <div className="col-md-6">
                            <label style={{ fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6, display: "block" }}>
                              Mobile Number <span style={{ color: "#ef4444" }}>*</span>
                            </label>
                            <div style={{ position: "relative" }}>
                              <i className="bx bx-phone" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 16 }} />
                              <input
                                name="mobile"
                                type="text"
                                value={mobile}
                                onChange={handleInputChange}
                                placeholder="Enter mobile number"
                                className={mobileError ? "form-control is-invalid" : "form-control"}
                                style={{ paddingLeft: 36, borderRadius: 8, borderColor: mobileError ? "#ef4444" : "#e2e8f0", fontSize: 14, height: 42 }}
                              />
                            </div>
                            {mobileError && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{mobileError}</div>}
                          </div>

                          {/* Email (read-only) */}
                          <div className="col-md-6">
                            <label style={{ fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6, display: "block" }}>
                              Email Address
                            </label>
                            <div style={{ position: "relative" }}>
                              <i className="bx bx-envelope" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 16 }} />
                              <input
                                name="email"
                                type="text"
                                value={email}
                                disabled={true}
                                placeholder="Email address"
                                className="form-control"
                                style={{ paddingLeft: 36, borderRadius: 8, borderColor: "#e2e8f0", fontSize: 14, height: 42, background: "#f8fafc", color: "#94a3b8", cursor: "not-allowed" }}
                              />
                            </div>
                            <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>Email cannot be changed</div>
                          </div>

                          {/* Password */}
                          <div className="col-md-6">
                            <label style={{ fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6, display: "block" }}>
                              Password <span style={{ color: "#353538" }}>(Leave empty to keep current)</span>
                            </label>
                            <div style={{ position: "relative" }}>
                              <i className="bx bx-lock-alt" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", fontSize: 16 }} />
                              <input
                                name="password"
                                type="text"
                                value={password}
                                onChange={handleInputChange}
                                placeholder="Enter password"
                                className={passwordError ? "form-control is-invalid" : "form-control"}
                                style={{ paddingLeft: 36, borderRadius: 8, borderColor: passwordError ? "#ef4444" : "#e2e8f0", fontSize: 14, height: 42 }}
                              />
                            </div>
                            {passwordError && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{passwordError}</div>}
                          </div>
                        </div>

                        {/* Submit */}
                        <div style={{ marginTop: 32, display: "flex", justifyContent: "flex-end" }}>
                          <button
                            type="submit"
                            style={{
                              background: "linear-gradient(135deg, #5b48e8, #7c3aed)",
                              border: "none",
                              borderRadius: 8,
                              padding: "10px 28px",
                              color: "#fff",
                              fontWeight: 600,
                              fontSize: 14,
                              cursor: "pointer",
                              boxShadow: "0 4px 12px rgba(91,72,232,0.3)",
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <i className="bx bx-check-circle" style={{ fontSize: 16 }} />
                            Update Profile
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
